Telescope.setConfig({
  watchHistoryAndHash: true,
  autoTrackClick: false,
  trackKey: 'b4503b0f31673416e35fc03c5e0158f0da776ccccd3f382c755000f55352a68d',
  version: process.env.VERSION
});

export default {
  install(Vue) {
    Vue.directive('track-event', Telescope.vTrackEvent);
    Vue.directive('track-page', Telescope.vTrackPage);
  }
};

export const TRACK_ACTIONS = {
  ZYWZPC_AMAP_FAIL: 'zywzpc-amap-fail',
  ZYWZPC_AMAP_CHECK_DISTANCE: 'zywzpc-amap-check-distance'
};

export function $telescopeEvent(config) {
  try {
    Telescope.trackEvent(config);
  } catch (err) {
    console.warn('telescope err = ', err);
  }
}
